import {
  GET_SURVEYS,
  GET_SURVEYS_SUCCESS,
  GET_SURVEYS_FAIL,
  GET_SURVEYS_RESET,
  CREATE_SURVEY,
  CREATE_SURVEY_SUCCESS,
  CREATE_SURVEY_FAIL,
  CREATE_SURVEY_RESET,
  GET_SURVEY_DETAIL,
  GET_SURVEY_DETAIL_SUCCESS,
  GET_SURVEY_DETAIL_FAIL,
  GET_SURVEY_DETAIL_RESET,
  SEND_SURVEY_PROMPT,
  SEND_SURVEY_PROMPT_SUCCESS,
  SEND_SURVEY_PROMPT_FAIL,
  SEND_SURVEY_PROMPT_RESET,
  ADD_SURVEY_QUESTION,
  ADD_SURVEY_QUESTION_SUCCESS,
  ADD_SURVEY_QUESTION_FAIL,
  ADD_SURVEY_QUESTION_RESET,
  UPDATE_SURVEY_QUESTION,
  UPDATE_SURVEY_QUESTION_SUCCESS,
  UPDATE_SURVEY_QUESTION_FAIL,
  UPDATE_SURVEY_QUESTION_RESET,
  DELETE_SURVEY_QUESTION,
  DELETE_SURVEY_QUESTION_SUCCESS,
  DELETE_SURVEY_QUESTION_FAIL,
  DELETE_SURVEY_QUESTION_RESET,
  UPDATE_SURVEY_DEMOGRAPHICS,
  UPDATE_SURVEY_DEMOGRAPHICS_SUCCESS,
  UPDATE_SURVEY_DEMOGRAPHICS_FAIL,
  UPDATE_SURVEY_DEMOGRAPHICS_RESET,
  SAVE_SURVEY,
  SAVE_SURVEY_SUCCESS,
  SAVE_SURVEY_FAIL,
  SAVE_SURVEY_RESET,
  REGENERATE_QUESTIONS,
  REGENERATE_QUESTIONS_SUCCESS,
  REGENERATE_QUESTIONS_FAIL,
  REGENERATE_QUESTIONS_RESET,
  REORDER_QUESTIONS,
  REORDER_QUESTIONS_SUCCESS,
  REORDER_QUESTIONS_FAIL,
  REORDER_QUESTIONS_RESET,
  COPY_SURVEY,
  COPY_SURVEY_SUCCESS,
  COPY_SURVEY_FAIL,
  COPY_SURVEY_RESET,
  DELETE_SURVEY,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAIL,
  DELETE_SURVEY_RESET,
} from '../actions/surveyAction';

const apiState = {
  apiState: 'idle',
  data: null,
  message: null,
  errors: null,
  error: null,
};

const initialState = {
  getSurveysState: { ...apiState },
  createSurveyState: { ...apiState },
  getSurveyDetailState: { ...apiState },
  sendSurveyPromptState: { ...apiState },
  addSurveyQuestionState: { ...apiState },
  updateSurveyQuestionState: { ...apiState },
  deleteSurveyQuestionState: { ...apiState },
  updateSurveyDemographicsState: { ...apiState },
  saveSurveyState: { ...apiState },
  regenerateQuestionsState: { ...apiState },
  reorderQuestionsState: { ...apiState },
  copySurveyState: { ...apiState },
  deleteSurveyState: { ...apiState },
};

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SURVEYS:
      return {
        ...state,
        getSurveysState: { ...state.getSurveysState, apiState: 'loading' },
      };
    case GET_SURVEYS_SUCCESS:
      return {
        ...state,
        getSurveysState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Surveys retrieved successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case GET_SURVEYS_FAIL:
      return {
        ...state,
        getSurveysState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch surveys',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_SURVEYS_RESET:
      return {
        ...state,
        getSurveysState: initialState.getSurveysState,
      };

    case CREATE_SURVEY:
      return {
        ...state,
        createSurveyState: { ...state.createSurveyState, apiState: 'loading' },
      };
    case CREATE_SURVEY_SUCCESS:
      return {
        ...state,
        createSurveyState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Survey created successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case CREATE_SURVEY_FAIL:
      return {
        ...state,
        createSurveyState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create survey',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_SURVEY_RESET:
      return {
        ...state,
        createSurveyState: initialState.createSurveyState,
      };

    case GET_SURVEY_DETAIL:
      return {
        ...state,
        getSurveyDetailState: { ...state.getSurveyDetailState, apiState: 'loading' },
      };
    case GET_SURVEY_DETAIL_SUCCESS:
      return {
        ...state,
        getSurveyDetailState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Survey detail retrieved successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case GET_SURVEY_DETAIL_FAIL:
      return {
        ...state,
        getSurveyDetailState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch survey detail',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_SURVEY_DETAIL_RESET:
      return {
        ...state,
        getSurveyDetailState: initialState.getSurveyDetailState,
      };

    case SEND_SURVEY_PROMPT:
      return {
        ...state,
        sendSurveyPromptState: { ...state.sendSurveyPromptState, apiState: 'loading' },
      };
    case SEND_SURVEY_PROMPT_SUCCESS:
      return {
        ...state,
        sendSurveyPromptState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Prompt accepted',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case SEND_SURVEY_PROMPT_FAIL:
      return {
        ...state,
        sendSurveyPromptState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to send prompt',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case SEND_SURVEY_PROMPT_RESET:
      return {
        ...state,
        sendSurveyPromptState: initialState.sendSurveyPromptState,
      };

    case ADD_SURVEY_QUESTION:
      return {
        ...state,
        addSurveyQuestionState: { ...state.addSurveyQuestionState, apiState: 'loading' },
      };
    case ADD_SURVEY_QUESTION_SUCCESS:
      return {
        ...state,
        addSurveyQuestionState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Question added',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case ADD_SURVEY_QUESTION_FAIL:
      return {
        ...state,
        addSurveyQuestionState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to add question',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case ADD_SURVEY_QUESTION_RESET:
      return {
        ...state,
        addSurveyQuestionState: initialState.addSurveyQuestionState,
      };

    case UPDATE_SURVEY_QUESTION:
      return {
        ...state,
        updateSurveyQuestionState: { ...state.updateSurveyQuestionState, apiState: 'loading' },
      };
    case UPDATE_SURVEY_QUESTION_SUCCESS:
      return {
        ...state,
        updateSurveyQuestionState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Question updated',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case UPDATE_SURVEY_QUESTION_FAIL:
      return {
        ...state,
        updateSurveyQuestionState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update question',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_SURVEY_QUESTION_RESET:
      return {
        ...state,
        updateSurveyQuestionState: initialState.updateSurveyQuestionState,
      };

    case DELETE_SURVEY_QUESTION:
      return {
        ...state,
        deleteSurveyQuestionState: { ...state.deleteSurveyQuestionState, apiState: 'loading' },
      };
    case DELETE_SURVEY_QUESTION_SUCCESS:
      return {
        ...state,
        deleteSurveyQuestionState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Question deleted',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case DELETE_SURVEY_QUESTION_FAIL:
      return {
        ...state,
        deleteSurveyQuestionState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete question',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_SURVEY_QUESTION_RESET:
      return {
        ...state,
        deleteSurveyQuestionState: initialState.deleteSurveyQuestionState,
      };

    case UPDATE_SURVEY_DEMOGRAPHICS:
      return {
        ...state,
        updateSurveyDemographicsState: { ...state.updateSurveyDemographicsState, apiState: 'loading' },
      };
    case UPDATE_SURVEY_DEMOGRAPHICS_SUCCESS:
      return {
        ...state,
        updateSurveyDemographicsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Demographics updated',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case UPDATE_SURVEY_DEMOGRAPHICS_FAIL:
      return {
        ...state,
        updateSurveyDemographicsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update demographics',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_SURVEY_DEMOGRAPHICS_RESET:
      return {
        ...state,
        updateSurveyDemographicsState: initialState.updateSurveyDemographicsState,
      };

    case SAVE_SURVEY:
      return {
        ...state,
        saveSurveyState: { ...state.saveSurveyState, apiState: 'loading' },
      };
    case SAVE_SURVEY_SUCCESS:
      return {
        ...state,
        saveSurveyState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Survey saved successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case SAVE_SURVEY_FAIL:
      return {
        ...state,
        saveSurveyState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to save survey',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case SAVE_SURVEY_RESET:
      return {
        ...state,
        saveSurveyState: initialState.saveSurveyState,
      };

    case REGENERATE_QUESTIONS:
      return {
        ...state,
        regenerateQuestionsState: { ...state.regenerateQuestionsState, apiState: 'loading' },
      };
    case REGENERATE_QUESTIONS_SUCCESS:
      return {
        ...state,
        regenerateQuestionsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Regeneration started',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case REGENERATE_QUESTIONS_FAIL:
      return {
        ...state,
        regenerateQuestionsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to regenerate questions',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case REGENERATE_QUESTIONS_RESET:
      return {
        ...state,
        regenerateQuestionsState: initialState.regenerateQuestionsState,
      };

    case REORDER_QUESTIONS:
      return {
        ...state,
        reorderQuestionsState: { ...state.reorderQuestionsState, apiState: 'loading' },
      };
    case REORDER_QUESTIONS_SUCCESS:
      return {
        ...state,
        reorderQuestionsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Questions reordered successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case REORDER_QUESTIONS_FAIL:
      return {
        ...state,
        reorderQuestionsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to reorder questions',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case REORDER_QUESTIONS_RESET:
      return {
        ...state,
        reorderQuestionsState: initialState.reorderQuestionsState,
      };

    case COPY_SURVEY:
      return {
        ...state,
        copySurveyState: { ...state.copySurveyState, apiState: 'loading' },
      };
    case COPY_SURVEY_SUCCESS:
      return {
        ...state,
        copySurveyState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Survey copied successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case COPY_SURVEY_FAIL:
      return {
        ...state,
        copySurveyState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to copy survey',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case COPY_SURVEY_RESET:
      return {
        ...state,
        copySurveyState: initialState.copySurveyState,
      };

    case DELETE_SURVEY:
      return {
        ...state,
        deleteSurveyState: { ...state.deleteSurveyState, apiState: 'loading' },
      };
    case DELETE_SURVEY_SUCCESS:
      return {
        ...state,
        deleteSurveyState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Survey deleted successfully',
          errors: action.response.errors || null,
          error: null,
        },
      };
    case DELETE_SURVEY_FAIL:
      return {
        ...state,
        deleteSurveyState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete survey',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_SURVEY_RESET:
      return {
        ...state,
        deleteSurveyState: initialState.deleteSurveyState,
      };

    default:
      return state;
  }
};

export default surveyReducer;


